import type { NavigationProp } from '@react-navigation/native';
import { showSuccessAfterModalClose } from '../../shared/ui/appToast';
import { navigateInShell } from '../../shell/navigation/rootNavigation';
import { dismissCustomerMaturityNudge, isCustomerMaturityNudgeDismissed } from './onboardingUiStorage';

const CUSTOMER_NUDGE_DELAY_MS = 3800;

/**
 * Toast 1× post venta customer (B5 liviana). Diferido para no pisar el toast de venta registrada.
 */
export function scheduleCustomerMaturityNudge(
  userId: string | undefined,
  navigation: NavigationProp<Record<string, unknown>>,
): void {
  if (!userId) return;
  setTimeout(() => {
    void maybeShowCustomerMaturityNudge(userId, navigation);
  }, CUSTOMER_NUDGE_DELAY_MS);
}

export async function maybeShowCustomerMaturityNudge(
  userId: string,
  navigation: NavigationProp<Record<string, unknown>>,
): Promise<void> {
  if (await isCustomerMaturityNudgeDismissed(userId)) return;
  await dismissCustomerMaturityNudge(userId);
  showSuccessAfterModalClose(
    '¿Llevás la cuenta en Customer?',
    'Mirá saldos y límites en un solo lugar.',
    7000,
    () => navigateInShell(navigation, 'Customers'),
  );
}
